/**
 * Chemin de l'ecran de moderation.
 *
 * Module **pur**, importe par l'ecran et par le registre de navigation : ecrire
 * le chemin en clair aux deux endroits le ferait diverger sans qu'aucun test
 * ne tombe.
 */
export const MODERATION_PATH = '/moderation';
